export default __webpack_public_path__ + "static/media/467-min.0fe3b918.png";